const API_BASE = process.env.REACT_APP_ROOM_NATE_API;
const API_VERSION = process.env.REACT_APP_ROOM_NATE_VERSION;
export const baseUrl = `${(API_BASE ?? "").replace(/\/$/, "")}/${API_VERSION ?? ""}`;

/**
 * Centralized API URL builder with validation.
 * @param {string} path - Path after /v2/ (may start with / or not)
 */
export function apiUrl(path) {
	const cleanBase = baseUrl.replace(/\/$/, "");
	const cleanPath = String(path || "").replace(/^\/+/, "");
	const url = `${cleanBase}/${cleanPath}`;
	if (url.includes("/undefined/") || url.endsWith("/undefined")) {
		throw new Error(`Bad apiUrl(): ${url}`);
	}
	return url.replace(/\/v2\/v2\//g, "/v2/");
}
